import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Track } from 'ngx-audio-player';
import { AudioData } from 'src/app/models/audioModel/audio-data.model';
import { audioUri } from 'src/app/models/audioModel/audioListModel';
import { audioResponse } from 'src/app/models/audioModel/audioResponse';

@Component({
  selector: 'app-audio-player',
  templateUrl: './audio-player.component.html',
  styleUrls: ['./audio-player.component.scss']
})
export class AudioPlayerComponent implements OnInit {

  fileSource: any;
  startTime: any = 0;
  endTime: any = 0;
  public audioUrl;
  url;
  title;

  msaapDisplayTitle = true;
  msaapDisplayPlayList = false;
  msaapPageSizeOptions = [2, 4, 6];
  msaapDisplayVolumeControls = true;
  msaapDisplayRepeatControls = false;
  msaapDisplayArtist = false;
  msaapDisplayDuration = true;
  msaapDisablePositionSlider = false;
  msaapPlaylist: Track[] = null;

  @Input() data: AudioData = null;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    

    this.setStartTime(this.data.startTime);

    this.endTime = this.data.endTime || 0;

    this.url = this.data.link;
    this.title = this.data.title;

    this.msaapPlaylist = [
      {
        link: this.url,
        title: this.title,
        artist: '',
      }
    ];
  }

  setStartTime(startTime: string) {
    this.startTime = 0;
    let startDate = null;
    if(typeof startTime !== 'string' || startTime == '') {
      return;
    }
    try {      
      startDate = new Date(startTime);
    } catch { return; }

    const hours = startDate.getHours();
    const minutes = startDate.getMinutes();
    const seconds = startDate.getSeconds();

    if (hours) {
      this.startTime += (hours * 60 * 60);
    }

    if (minutes) {
      this.startTime += (minutes * 60);
    }

    this.startTime += seconds;
  }

}
